




















import { ValidationProvider } from 'vee-validate'
import { Component, Prop, PropSync, Vue } from 'vue-property-decorator'

import { docsLink } from '@/utils/constants'

@Component({
  components: {
    ValidationProvider,
  },
})
export default class Agreement extends Vue {
  @PropSync('value', { required: true })
  private innerValue!: boolean

  @Prop({ default: 'policy' })
  private type!: 'policy' | 'payment'

  @Prop({ default: false })
  private noConfidentialLink!: boolean

  private docsLink = docsLink
}
